import React, { useContext } from 'react';
import EmptyBackground from '../EmptyBackground';
import BackgroundImage from '../../BackgroundImage';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ThemeContext, ThemeSkinContext, } from '@wix/da-react-context/pkg/ThemeContext';
import { getBackgroundVariant } from '../../redux/helpers';
var LARGE_BACKGROUND_MIN_SIZE = 1300;
function pickBackgroundSrc(_a, variant, width) {
    var darkBigUrl = _a.darkBigUrl, darkSmallUrl = _a.darkSmallUrl, lightBigUrl = _a.lightBigUrl, lightSmallUrl = _a.lightSmallUrl, _b = _a.greenBigUrl, greenBigUrl = _b === void 0 ? lightBigUrl : _b, _c = _a.greenSmallUrl, greenSmallUrl = _c === void 0 ? lightSmallUrl : _c;
    var useLarge = width && width > LARGE_BACKGROUND_MIN_SIZE;
    switch (variant) {
        case 'green':
            return useLarge ? greenBigUrl : greenSmallUrl;
        case 'light':
            return useLarge ? lightBigUrl : lightSmallUrl;
        case 'dark':
        default:
            return useLarge ? darkBigUrl : darkSmallUrl;
    }
}
var DefaultStageBackground = function (_a) {
    var width = _a.width, deviation = _a.deviation, _b = _a.background, background = _b === void 0 ? deviation.background || 'default' : _b;
    var isMobile = useContext(MobileContext);
    var theme = useContext(ThemeContext);
    var themeSkin = useContext(ThemeSkinContext);
    if (background === 'default' || isMobile) {
        return React.createElement(EmptyBackground, null);
    }
    return (React.createElement(BackgroundImage, { src: pickBackgroundSrc(background, getBackgroundVariant(theme, themeSkin), width), fade: "small" }));
};
DefaultStageBackground.displayName = 'DefaultStageBackground';
export default DefaultStageBackground;
//# sourceMappingURL=Default.js.map